<template>
  <div class="editableimage-wrap">
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>Drop files to upload</h3>
    </div>
    <div class="editableimage-upload"  v-show="!edit">
      <div class="text-center p-2">
        <label for="editableimage">
          <img ref="imagePreview" :src="files.length ? files[0].url : imageSrc" />
          <a v-if="editbutton" ref="editbutton" @click="editImage" class="image-edit-button btn btn-outline-light" href="javascript:"><i class="fa fa-crop"></i></a>
        </label>
      </div>
      <div class="text-center p-2">
        <file-upload
          extensions="gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp"
          name="media"
          :inputId="inputId"
          class="btn btn-cyan"
          post-action="/deck/media/store"
          :drop="!edit"
          v-model="files"
          @input-filter="inputFilter"
          @input-file="inputFile"
          ref="upload"
          :headers="{'X-CSRF-TOKEN': csrfToken}"
          >
          {{ uploadButtonLabel }}
        </file-upload>
      </div>
    </div>

    <div class="editableimage-edit" v-show="files.length && edit">
      <div class="editableimage-edit-image" v-if="files.length">
        <img ref="editImage" :src="files[0].url" />
      </div>
      <div class="text-center p-4">
        <button type="button" class="btn btn-secondary" @click.prevent="$refs.upload.clear();$emit('stopEditingImage');">Cancel</button>
        <button type="submit" class="btn btn-primary" @click.prevent="editSave">Save</button>
      </div>
    </div>
  </div>
</template>
<style type="text/css">
  .image-edit-button{
    position: absolute;
    top: 5px;
    right: 5px;
  }
  .image-edit-button.btn-outline-light{
      color: #ddd;
      border-color: #ddd;
  }
  .editableimage-upload label[for="editableimage"]{
    position: relative;
  }

  .editableimage-wrap img {
    display: block;
    /* This rule is very important, please don't ignore this */
    max-width: 100%;
  }
  .file-uploads{
    min-width: 160px;
  }
</style>
<script>
import Cropper from 'cropperjs'
import FileUpload from 'vue-upload-component'
export default {
  components: {
    FileUpload,
  },
  props: ['image','reference','editbutton','inputId','maxsize','uploadButtonText'],
  mounted: function () {
    this.csrfToken = $('meta[name="csrf-token"]').attr('content');
    if(!this.image){this.editbutton=false;}
    if(this.maxfilesize == null){
      this.maxfilesize = 1.5;
    }
  },
  data() {
    return {
      csrfToken : '',
      imageSrc : this.image,
      imageRef : this.reference,
      files: [],
      edit: false,
      cropper: false,
      maxfilesize: this.maxsize,
      uploadButtonLabel: this.uploadButtonText ? this.uploadButtonText : 'Upload Image'
    }
  },
  watch: {
    image(){
       this.$refs.imagePreview.src = this.image;
    },
    edit(value) {
      if (value) {
        this.$nextTick(function () {
          if (!this.$refs.editImage) {
            return
          }
          let cropper = new Cropper(this.$refs.editImage, {
            viewMode: 1,
          })
          this.cropper = cropper
        })
      } else {
        if (this.cropper) {
          this.cropper.destroy()
          this.cropper = false
        }
      }
    }
  },

  methods: {
      editImage(value){
      
      var vm = this;

      this.$emit('editingImage',value);

      axios({
        method: 'get',
        url: vm.$refs.imagePreview.src,
        responseType: 'blob'
          }).then(function(response){
               
               let img = response.data;
                   img.name = vm.$refs.imagePreview.src.substring(vm.$refs.imagePreview.src.lastIndexOf('/')+1);

               vm.inputFile(img);
               vm.$refs.upload.add(img);
               vm.edit = true;

          })

    },
    editSave() {
      
      this.edit = false

      let oldFile = this.files[0]

      let binStr = atob(this.cropper.getCroppedCanvas().toDataURL(oldFile.type).split(',')[1])
      let arr = new Uint8Array(binStr.length)
      for (let i = 0; i < binStr.length; i++) {
        arr[i] = binStr.charCodeAt(i)
      }

      let file = new File([arr], oldFile.name, { type: oldFile.type })

      this.$refs.upload.update(oldFile.id, {
        file,
        type: file.type,
        size: file.size,
        active: true,
      });

    },

    alert(message) {
      alert(message)
    },

    inputFile(newFile, oldFile, prevent) {

      if (newFile && !oldFile) {
        this.$nextTick(function () {
          this.edit = true
        })
      }
      if (!newFile && oldFile) {
        this.edit = false
      }

      if (newFile && oldFile && !newFile.active && oldFile.active) {
        
        if (newFile.response.status && newFile.response.status == 'success') {
          
          // If successful then emit image url
          console.log(newFile.response);
          var newImageSrc = {reference:this.imageRef, src:newFile.response.url};

          this.$emit('newImageSrc',newImageSrc);
          this.$emit('stopEditingImage');


        }
      }

    },

    inputFilter(newFile, oldFile, prevent) {


      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.alert('Oops, we don\'t support this file format. Please upload images as JPG, PNG or GIF')
          return prevent()
        }

        if(newFile.size > this.maxfilesize*1024000){
          this.alert('The image you are trying to upload is too large, please use a smaller image (under '+ this.maxfilesize +' MB)');
          return prevent()
        }

      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file)

        }
      }


    }
  }
}
</script>
